module.exports = __webpack_public_path__ + "static/media/WfsSearch.b25396c2.less";